import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { ISchoolFeature } from '../home.interface';
interface IProps {
  schdistfeature: ISchoolFeature;
  index: number;
}
export const Schooldistrictfeature = t0 => {
  const $ = _c(14);
  const {
    schdistfeature,
    index
  } = t0;
  const {
    imageUrl,
    title,
    description,
    alt
  } = schdistfeature;
  const defaultImage = `${imageUrl}/feature_${index}-1x.png`;
  const t1 = `mx-2 mt-12 flex flex-col items-center justify-center gap-y-2 px-4 md:mx-0 md:flex-row md:gap-x-[5%] md:gap-y-0 md:px-[5%] lg:gap-x-[10%] lg:px-[2%] ${index % 2 === 0 ? "mt-12 md:flex-row-reverse xl:mt-4" : ""}`;
  const t2 = imageUrl ? `${imageUrl}/feature_${index}-2x.png` : defaultImage;
  let t3;
  if ($[0] !== alt || $[1] !== t2) {
    t3 = <div className="w-[80%] md:w-[60%] lg:w-[50%] "><Image src={t2} width={1024} height={1024} alt={alt} /></div>;
    $[0] = alt;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = <div className="mt-4 text-[22px] font-medium text-[#3D3E40] md:text-[26px] lg:text-4xl">{title}</div>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== description) {
    t5 = <div className="ml-4 w-[90%] py-4 text-[15px] font-normal text-[#616366] md:ml-0 md:text-[18px]">{description}</div>;
    $[5] = description;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="mt-1 flex flex-col text-center md:-mt-4 md:w-[60%] md:text-start lg:max-w-[40%]">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t1 || $[11] !== t3 || $[12] !== t6) {
    t7 = <div className={t1}>{t3}{t6}</div>;
    $[10] = t1;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};